// TODO: Change id to other filed to avoid confusion because ID can change, we need such a value that is stable
export const NO_REPORT_TO_ID = '1ea819ce-dae8-4f50-abdc-61ad474c49a2';

export const DEPARTMENT_ORG_CHART_ROOT_NODE_ID = '1';
export const PEOPLE_ORG_CHART_ROOT_NODE_POSITION = 'CEO';

export const WITHOUT_PROJECT_DEPARTMENT_ID = 'without-project';
export const CLOSED_OR_MISSING_PROJECT_DEPARTMENT_ID = 'closed-or-missing-project';

export const VIRTUAL_ORG_CHART_DEPARTMENT_IDS = new Set([
  WITHOUT_PROJECT_DEPARTMENT_ID,
  CLOSED_OR_MISSING_PROJECT_DEPARTMENT_ID,
]);
